import { render, staticRenderFns } from "./CaseStatusForm.vue?vue&type=template&id=0f1a24d9"
import script from "./CaseStatusForm.vue?vue&type=script&lang=js"
export * from "./CaseStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports